import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
//使用animate动画库
import animated from 'animate.css'
Vue.use(animated)
Vue.config.productionTip = false
import $ from 'jquery'
Vue.config.$ = $
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { default global options } */)
import CONFIG from "./config";
Vue.prototype.$config = CONFIG
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
